import RolApiService from '@/modules/admin/services/RolApiService';
import {createPaginationHook} from '@/utils/createPaginationHook';

export const useSearchRol = createPaginationHook('user-roles', (params) => RolApiService.getRoles(params));
